<template>
	<v-container
		v-show="showList"
		xs12
		class="pt-2 text-xs-left"
	>
		<v-layout
			row
			wrap
		>
			<v-flex
				v-show="filteredErrorItems.length > 0"
				xs12
				class="py-0"
			>
				<div class="title">
					Notifications ({{ filteredErrorItems.length }})
					<v-btn
						icon
						flat
						@click="showErrorItems = !showErrorItems"
					>
						<v-icon v-if="showErrorItems">arrow_drop_up</v-icon>
						<v-icon v-else>arrow_drop_down</v-icon>
					</v-btn>
				</div>
			</v-flex>
			<transition name="slide-y-transition">
				<v-flex v-if="showErrorItems && filteredErrorItems.length > 0" xs12 class="pa-0">
					<transition-group name="slide-x-transition" tag="v-flex">
						<div
							v-for="error in filteredErrorItems"
							:key="error.url"
							class="py-2"
						>
							<v-layout
								row
								align-center
							>
								<v-flex shrink>
									<v-icon :color="error.tag">{{ error.tag }}</v-icon>
								</v-flex>
								<v-flex>
									<p class="body-2 mb-0">{{ error.message }}</p>
									<p class="break-word mb-0">{{ error.url }}</p>
								</v-flex>
								<v-flex shrink>
									<v-btn
										v-if="error.tag === 'warning'"
										:loading="error.loading"
										small
										outline
										@click="retry(error)"
									>
										<v-icon small class="mr-1">add</v-icon> add anyway
									</v-btn>
									<v-btn
										v-else
										:loading="error.loading"
										small
										outline
										@click="retry(error)"
									>
										<v-icon small class="mr-1">refresh</v-icon> refetch
									</v-btn>
								</v-flex>
							</v-layout>
						</div>
					</transition-group>
				</v-flex>
			</transition>
			<v-flex
				v-show="filteredSuccessItems.length > 0"
				xs12
				class="py-0 success--text"
			>
				<div class="title">
					Added ({{ filteredSuccessItems.length }})
					<v-btn
						icon
						flat
						@click="showSuccessItems = !showSuccessItems"
					>
						<v-icon v-if="showSuccessItems">arrow_drop_up</v-icon>
						<v-icon v-else>arrow_drop_down</v-icon>
					</v-btn>
				</div>
			</v-flex>
			<transition name="slide-y-transition">
				<template v-if="showSuccessItems">
					<transition-group name="slide-x-transition" tag="v-flex">
						<v-flex
							v-for="success in filteredSuccessItems"
							:key="success.id"
							xs12
							class="py-2"
						>
							<v-layout
								row
								align-center
							>
								<v-flex>
									<v-icon color="success">done</v-icon>
								</v-flex>
								<v-flex xs12>
									<div class="body-2">{{ success.title }}</div>
									<div class="break-word">{{ success.url }}</div>
								</v-flex>
							</v-layout>
						</v-flex>
					</transition-group>
				</template>
			</transition>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: {
		errorItems: { type: Array, default: () => [] },
		successItems: { type: Array, default: () => [] },
	},
	data() {
		return {
			showSuccessItems: false,
			showErrorItems: true,
		};
	},
	computed: {
		showList() {
			if (this.errorItems.length > 0 || this.filteredSuccessItems.length > 0) {
				return true;
			}
			return false;
		},
		filteredSuccessItems() {
			// if success item is deleted after added, we don't want it here anymore
			return this.successItems.filter(item => item.id);
		},
		filteredErrorItems() {
			return this.errorItems.filter(item => item.url);
		},
	},
	methods: {
		retry(article) {
			if (article.tagAction === 'refetch') {
				this.refetchArticle(article);
				return;
			}
			this.saveArticle(article);
		},
		saveArticle(article) {
			article.loading = true;
			article.save().then(() => {
				this.$emit('retry-success', article);
				this.$notify('success', 'Article added.');
			}).catch(() => {
				this.$notify('error', 'Failed to add article.');
			}).finally(() => {
				article.loading = false;
			});
		},
		refetchArticle(article) {
			article.refetch().then(() => {
				this.$emit('retry-success', article);
				this.$notify('success', 'Article refetched.');
			}).catch(() => {
				this.$notify('error', 'Failed to refetch article, try manually add data by clicking Edit.');
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.break-word {
	word-break: break-word;
}
</style>
